module.exports = __webpack_public_path__ + "img/ic_food_korea.96023f89.png";